'use client';

import { Typography } from '@coolblue-development/freddy';
import { useEffect, useRef, useState } from 'react';

export const LinkDescription = ({ description }: { description: string }) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const [truncateLines, setTruncateLines] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (ref.current) {
      // The added 8px is to account for the margin-bottom of the header which shrinks when the card is in focus, allowing the description to take up more space
      const availableHeight = ref.current?.clientHeight + 8;

      setTruncateLines(
        Math.floor(availableHeight / Number.parseInt(getComputedStyle(ref.current).lineHeight))
      );
    }
  }, [ref.current?.clientHeight]);

  return (
    <Typography
      ref={ref}
      truncateLines={truncateLines}
      mb={200}
      sx={{
        maxHeight: '-webkit-fill-available'
      }}
    >
      {description}
    </Typography>
  );
};
